import "../Styles/MainPage.css";
import Slider from "react-slick";
import FoodItem from "../Components/FoodItem";
import logo from "../Images/MainLogo.svg";
import LanguageSelector from "../Components/LanguageSelector";
import { useState, useEffect, useRef } from "react";
import { HiArrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cartIcon from "../Images/cart.svg";
import BeatLoader from "react-spinners/BeatLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategories,
  getCategoriesAndProducts,
  getProducts,
  setMenuType,
} from "../store/action/menu/menu";
import AxiosProvider from "../AxiosProvider";
import { applicationId } from "../config";

function MainPage() {
  const search = window.location.search;
  const menuState = useSelector((state) => state.menu);
  const categories = Array.isArray(menuState?.categories) ? menuState.categories : [];
  const bucket = useSelector((state) => state.cart.bucket) || [];

  const params = new URLSearchParams(search);
  const [categoryLoad, setCategoryLoad] = useState(false);
  const [prodId, setProdId] = useState(menuState?.menuType?.id);
  const topRef = useRef();
  const dispatch = useDispatch();
  const languageState = useSelector((state) => state.language);
  const { t, i18n } = useTranslation();
  const [type, setType] = useState(menuState?.menuType ?? {});
  const [branchName, setBranchName] = useState();
  const [allProductsByCategory, setAllProductsByCategory] = useState({});
  const [loadingProducts, setLoadingProducts] = useState(false);
  const branchData = localStorage.getItem("branch");
  let branch = null;
  try {
    branch = branchData ? JSON.parse(branchData) : null;
  } catch (e) {
    branch = null;
  }
  if (branch && (typeof branch !== "object" || Array.isArray(branch))) {
    branch = null;
    localStorage.removeItem("branch");
  }
  const totalItems = bucket.reduce(
    (total, item) => total + Number(item.quantity ?? 1),
    0
  );
  const totalPrice = bucket.reduce(
    (total, item) => total + (item.price || 0) * (item.quantity ?? 1),
    0
  );


  // Fetch categories and products in a single API call
  useEffect(() => {
    localStorage.removeItem("sk")
    localStorage.removeItem("notes")
    
    const branchId = JSON.parse(localStorage.getItem("branchId"));
    if (!branchId) return;

    setLoadingProducts(true);
    const fetchCategoriesAndProducts = async () => {
      try {
        const data = await dispatch(getCategoriesAndProducts());
        
        // Process products by category from the response
        // The API typically returns categories with products nested in each category
        const productsByCategory = {};
        
        // Get categories from the response data
        const categories = data.categories || data || [];
        
        // Process products - check if categories have products nested in them
        if (Array.isArray(categories)) {
          categories.forEach((category) => {
            // Check if category has products property
            if (category.products && Array.isArray(category.products)) {
              productsByCategory[category.id] = category.products;
            } else {
              productsByCategory[category.id] = [];
            }
          });
        }
        
        // If products are in a separate array, group them by categoryId
        if (data.products && Array.isArray(data.products) && Object.keys(productsByCategory).length === 0) {
          data.products.forEach((product) => {
            if (product.categoryId) {
              if (!productsByCategory[product.categoryId]) {
                productsByCategory[product.categoryId] = [];
              }
              productsByCategory[product.categoryId].push(product);
            }
          });
        }
        
        setAllProductsByCategory(productsByCategory);
      } catch (error) {
        console.error('Error fetching categories and products:', error);
        setAllProductsByCategory({});
      } finally {
        setLoadingProducts(false);
      }
    };
    
    fetchCategoriesAndProducts();
  }, [
    dispatch,
    languageState.lang,
    i18n.language,
  ]);

  // Removed - we now load all products at once, no need to fetch on category change
  // useEffect(() => {
  //   const branchId = JSON.parse(localStorage.getItem("branchId"));
  //   if (prodId !== null) {
  //     dispatch(getProducts(prodId, null, branchId));
  //     setCategoryLoad(false);
  //   }
  // }, [dispatch, prodId, languageState.lang]);

  useEffect(() => {
    setBranchName(JSON.parse(window.localStorage.getItem("branchName")));
    console.log(branchName);
  }, []);

  const [isManualCategoryChange, setIsManualCategoryChange] = useState(false);
  const manualScrollTimeoutRef = useRef(null);
  const userScrollDetectedRef = useRef(false);
  const lastScrollTopRef = useRef(0);
  const programmaticScrollRef = useRef(false);

  useEffect(() => {
    if (!type?.value || !isManualCategoryChange) return;

    // Set flag to indicate programmatic scroll is happening
    programmaticScrollRef.current = true;
    userScrollDetectedRef.current = false;

    // Scroll category button in the horizontal scroll menu
    const scrollContainer = document.getElementById("scroll");
    if (scrollContainer) {
      const targetId = `cat-${type.id}`;
      let attempts = 0;
      const maxAttempts = 60;

      const tryScroll = () => {
        const activeElement = document.getElementById(targetId);
        if (activeElement) {
          activeElement.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        } else if (attempts < maxAttempts) {
          attempts++;
          requestAnimationFrame(tryScroll);
        }
      };

      requestAnimationFrame(tryScroll);
    }

    // Scroll to category section in the main content
    const categorySectionId = `category-section-${type.id}`;
    
    // Try immediately first
    const categorySection = document.getElementById(categorySectionId);
    if (categorySection) {
      // Use requestAnimationFrame for smooth scroll without delay
      requestAnimationFrame(() => {
        categorySection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    } else {
      // Only retry if element not found (shouldn't happen since all categories are loaded)
      let contentAttempts = 0;
      const maxContentAttempts = 10; // Reduced attempts
      
      const tryScrollToContent = () => {
        const section = document.getElementById(categorySectionId);
        if (section) {
          section.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else if (contentAttempts < maxContentAttempts) {
          contentAttempts++;
          requestAnimationFrame(tryScrollToContent);
        }
      };
      
      requestAnimationFrame(tryScrollToContent);
    }

    // Clear any existing timeout
    if (manualScrollTimeoutRef.current) {
      clearTimeout(manualScrollTimeoutRef.current);
    }

    // Reset flags after scroll animation completes (smooth scroll takes ~500ms)
    manualScrollTimeoutRef.current = setTimeout(() => {
      setIsManualCategoryChange(false);
      programmaticScrollRef.current = false;
      manualScrollTimeoutRef.current = null;
    }, 600);

    return () => {
      if (manualScrollTimeoutRef.current) {
        clearTimeout(manualScrollTimeoutRef.current);
        manualScrollTimeoutRef.current = null;
      }
    };
  }, [type, isManualCategoryChange]);

  // Function to handle category changes
  function handleSet(string, number) {
    if (!(type?.id === number)) {
      // Clear any existing manual scroll timeout
      if (manualScrollTimeoutRef.current) {
        clearTimeout(manualScrollTimeoutRef.current);
        manualScrollTimeoutRef.current = null;
      }
      
      // Set the flag to prevent scroll spy interference
      setIsManualCategoryChange(true);
      
      // Update state - this will cause re-render and deactivate previous button
      setType({ value: string, id: number });
      dispatch(setMenuType({ value: string, id: number }));
      localStorage.setItem(
        "activCateg",
        JSON.stringify({ value: string, id: number })
      );
      // Removed setProdId - we don't fetch products on category change anymore
    }
  }
  useEffect(() => {
    if (categories.length == 0) {
      dispatch(getCategories());
    }

    document.title =
      i18n.language === "ar" ? "مطاعم الرومانسية" : "Al Romansiah Restaurant";
  }, [dispatch]);

  // Scroll spy to detect which category is in view
  useEffect(() => {
    if (categories.length === 0 || loadingProducts) return;

    let scrollTimeout = null;

    const handleScroll = () => {
      // Detect if this is a user-initiated scroll
      const currentScrollTop = window.scrollY;
      const scrollDelta = Math.abs(currentScrollTop - lastScrollTopRef.current);
      
      // If scroll delta is significant and we're in programmatic scroll mode, user has taken over
      if (scrollDelta > 10 && programmaticScrollRef.current) {
        userScrollDetectedRef.current = true;
        // User started scrolling manually, cancel the programmatic scroll flag
        if (manualScrollTimeoutRef.current) {
          clearTimeout(manualScrollTimeoutRef.current);
          manualScrollTimeoutRef.current = null;
        }
        setIsManualCategoryChange(false);
        programmaticScrollRef.current = false;
      }
      
      lastScrollTopRef.current = currentScrollTop;

      // Clear previous timeout
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }

      // Debounce scroll events (reduced for faster response)
      scrollTimeout = setTimeout(() => {
        // Skip update ONLY if programmatic scroll is happening AND user hasn't taken over
        if (isManualCategoryChange && !userScrollDetectedRef.current) {
          return;
        }
        
        // Find which category section is currently in view
        const categoriesWithProducts = categories.filter(
          (cat) => allProductsByCategory[cat.id] && allProductsByCategory[cat.id].length > 0
        );

        if (categoriesWithProducts.length === 0) return;

        const stickyHeaderHeight = 200; // Approximate height of sticky header + categories row
        const scrollPosition = window.scrollY;
        const effectiveViewportTop = scrollPosition + stickyHeaderHeight;
        let activeCategory = null;
        let candidatesAbove = [];
        let candidatesBelow = [];

        // Find all visible category sections and categorize them
        categoriesWithProducts.forEach((category) => {
          const section = document.getElementById(`category-section-${category.id}`);
          
          if (section) {
            const rect = section.getBoundingClientRect();
            const sectionTop = scrollPosition + rect.top;
            const sectionBottom = sectionTop + rect.height;
            
            // Section is visible if any part of it is in the viewport
            const isVisible = sectionBottom > scrollPosition && sectionTop < scrollPosition + window.innerHeight;
            
            if (isVisible) {
              const distanceFromTop = sectionTop - effectiveViewportTop;
              
              // Categorize: sections at or above viewport top vs below
              if (distanceFromTop <= 50) { // Within 50px threshold
                if (distanceFromTop <= 0) {
                  // Section is at or above effective viewport top (we're viewing it or haven't passed it)
                  candidatesAbove.push({ category, distance: Math.abs(distanceFromTop) });
                } else {
                  // Section is below effective viewport top (we've scrolled past it)
                  candidatesBelow.push({ category, distance: distanceFromTop });
                }
              }
            }
          }
        });

        // Prefer sections above viewport top (we're currently viewing them)
        if (candidatesAbove.length > 0) {
          // Sort by distance (closest to viewport top first)
          candidatesAbove.sort((a, b) => a.distance - b.distance);
          activeCategory = candidatesAbove[0].category;
        } else if (candidatesBelow.length > 0) {
          // If no sections above, use the closest one below (we just scrolled past it)
          candidatesBelow.sort((a, b) => a.distance - b.distance);
          activeCategory = candidatesBelow[0].category;
        }

        // Update active category if it's different
        // This will automatically deactivate the previous category and activate the new one
        if (activeCategory && type && type.id !== activeCategory.id) {
          // Update state - this ensures only ONE button is active at a time
          const newType = { value: activeCategory.enName, id: activeCategory.id };
          setType(newType);
          dispatch(setMenuType(newType));
          localStorage.setItem("activCateg", JSON.stringify(newType));

          // Scroll category button in the horizontal menu
          requestAnimationFrame(() => {
            const scrollContainer = document.getElementById("scroll");
            if (scrollContainer) {
              const targetId = `cat-${activeCategory.id}`;
              const activeElement = document.getElementById(targetId);
              if (activeElement) {
                activeElement.scrollIntoView({
                  behavior: "smooth",
                  inline: "center",
                  block: "nearest",
                });
              }
            }
          });
        }
      }, 100); // Slightly increased debounce for more stable detection
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    
    // Initial check after a delay to ensure DOM is ready
    const initialTimeout = setTimeout(() => {
      handleScroll();
    }, 300);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      if (initialTimeout) {
        clearTimeout(initialTimeout);
      }
    };
  }, [categories, allProductsByCategory, loadingProducts, type, dispatch, isManualCategoryChange]);

  // Determine current language and direction - use both i18n and Redux state as fallback
  const currentLang = i18n.language || languageState.lang || 'ar';
  const isRTL = currentLang === 'ar' || currentLang === 'ur';

  return (
    <div className="MainMenu ">
      {menuState.loading ? (
        <div className="loader">
          <BeatLoader color={"#E57200"} loading={menuState.loading} size={30} />
        </div>
      ) : (
        <>
          {/* Header Section - Not sticky */}
          <div style={{ backgroundColor: "white", direction: isRTL ? "rtl" : "ltr" }}>
            <div className="container-fluid" style={{ direction: isRTL ? "rtl" : "ltr" }}>
              <div 
                ref={topRef} 
                style={{ 
                  display: "flex",
                  flexDirection: "column",
                  direction: isRTL ? "rtl" : "ltr",
                  width: "100%"
                }}
              >
                <div
                  style={{ 
                    display: "flex", 
                    margin: "0", 
                    position: "relative", 
                    justifyContent: "space-between", 
                    alignItems: "center", 
                    width: "100%",
                    direction: isRTL ? "rtl" : "ltr"
                  }}
                  className="langSwitch pt-4 "
                >
                  <img src={logo} alt="logo" className="main-logo" style={{ width: "150px", height: "auto", marginTop: "15px" }} />
                  <div style={{ flex: 1 }}></div>
                  <LanguageSelector currentLang={languageState.lang} />
                </div>
                {branch && (
                  <div 
                    style={{ 
                      display: "flex", 
                      flexDirection: "row", 
                      alignItems: "center", 
                      gap: "8px",
                      marginTop: "10px", 
                      marginBottom: "5px",
                      paddingTop: "8px",
                      paddingBottom: "8px",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                      width: "100%",
                      direction: isRTL ? "rtl" : "ltr", 
                      justifyContent: isRTL ? "flex-start" : "flex-start"
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
                      <div className={`text-stone-600 font-normal font-cairo leading-none ${i18n.language == "ar" || i18n.language == "ur" ? "text-xs" : "text-[10px]"}`}>{t('theBranch')}:</div>
                      <div className={`text-stone-700 font-medium font-cairo leading-none ${i18n.language == "ar" || i18n.language == "ur" ? "text-xs" : "text-[10px]"}`}>
                        {i18n.language == "ar" || i18n.language == "ur"
                          ? branch?.arName ?? ""
                          : branch?.enName ?? ""}
                      </div>
                    </div>
                    {(i18n.language == "ar" || i18n.language == "ur") && (
                      <div style={{ width: "2px", height: "32px", backgroundColor: "#E2E5E8" }}></div>
                    )}
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
                      <div className={`text-stone-600 font-normal font-cairo leading-none ${i18n.language == "ar" || i18n.language == "ur" ? "text-xs" : "text-[10px]"}`}>{t('orderType')}:</div>
                      <div className={`text-stone-700 font-medium font-cairo leading-none ${i18n.language == "ar" || i18n.language == "ur" ? "text-xs" : "text-[10px]"}`}>
                        {localStorage.getItem("typeId") == 5
                          ? `${t("LandingPage.type2")} `
                          : localStorage.getItem("typeId") == 3
                            ? t("LandingPage.type3")
                            : t("LandingPage.type1")}
                      </div>
                    </div>
                    {localStorage.getItem("tableName") != null && (i18n.language == "ar" || i18n.language == "ur") && (
                      <div style={{ width: "2px", height: "32px", backgroundColor: "#E2E5E8" }}></div>
                    )}
                    {localStorage.getItem("tableName") != null && (
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
                        <div className={`text-stone-600 font-normal font-cairo leading-none ${i18n.language == "ar" || i18n.language == "ur" ? "text-xs" : "text-[10px]"}`}>{t('tableName')}:</div>
                        <div className={`text-stone-700 font-medium font-cairo leading-none ${i18n.language == "ar" || i18n.language == "ur" ? "text-xs" : "text-[10px]"}`}>{localStorage.getItem("tableName")}</div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Categories Row - Sticky */}
          <div style={{ backgroundColor: "white", position: "sticky", top: 0, zIndex: 100, marginTop: 0, paddingTop: 0 }}>
            <div
              style={
                languageState.lang === "en" || languageState.lang === "id"
                  ? { direction: "ltr", backgroundColor: "white", marginTop: 0, marginBottom: 0 }
                  : { backgroundColor: "white", marginTop: 0, marginBottom: 0 }
              }
              id="scroll"
              className="scrollmenu"
            >
              {categories.map((data, index) => {
                const isActive = type && type.id === data.id;
                return (
                  <div id={`cat-${data.id}`} key={data.id}>
                    <button
                      onClick={() => handleSet(data.enName, data.id)}
                      className={isActive ? "activeBtn" : ""}
                    >
                      {data.name ?? "not found"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
         

          {/* Products Content */}
          {loadingProducts ? (
            <div className="loader" style={{ height: "66vh" }}>
              <BeatLoader color={"#E57200"} loading={loadingProducts} size={30} />
            </div>
          ) : (
            <div className="container-fluid2">
              <div
                style={
                  i18n.language === "ar"
                    ? { direction: "rtl" }
                    : { direction: "ltr" }
                }
                className="row "
              >
                {categories.map((category) => {
                  const categoryProducts = allProductsByCategory[category.id] || [];
                  
                  if (categoryProducts.length === 0) {
                    return null;
                  }

                  return (
                    <div key={category.id} id={`category-section-${category.id}`} style={{ width: "100%" }}>
                      {/* Category Title */}
                      <div 
                        style={{
                          width: "100%",
                          textAlign: i18n.language === "ar" ? "right" : "left",
                          color: "#831843",
                          fontSize: "18px",
                          fontWeight: "700",
                          fontFamily: "Graphik_Arabic, sans-serif",
                          lineHeight: "32px",
                          marginTop: category.id !== categories[0]?.id ? "0.5rem" : "0.5rem",
                          marginBottom: "0.5rem",
                          paddingLeft: i18n.language === "ar" ? "0" : "1rem",
                          paddingRight: i18n.language === "ar" ? "1rem" : "0",
                        }}
                      >
                        {category.name ?? "not found"}
                      </div>
                      
                      {/* Category Items */}
                      {categoryProducts.map((data, index) => {
                        return (
                          <FoodItem
                            key={`${category.id}-${data.id}-${index}`}
                            currency={
                              languageState.lang === "ar"
                                ? data.arCurrency
                                : data.enCurrency
                            }
                            name={data.name ?? "not found"}
                            active={data.active !== undefined ? data.active === 1 : true}
                            image={data.image}
                            des={
                              languageState.lang === "ar"
                                ? data.arDescription
                                : data.enDescription
                            }
                            price={data.price}
                            id={data.id}
                          />
                        );
                      })}
                    </div>
                  );
                })}
                
                {/* Show message if no products at all */}
                {categories.length > 0 && 
                 Object.values(allProductsByCategory).every(products => !products || products.length === 0) && (
                  <div style={{ textAlign: "center", width: "100%" }}>
                    <p
                      style={{
                        fontSize: "28px",
                        fontFamily: "cairo",
                        marginTop: "20vh",
                      }}
                    >
                      {t("Single_product.noMeals")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          {bucket.length > 0 && (
            <div className="menuCartBar">
              <div className="menuCartBarInfo">
                <img src={cartIcon} alt="cart" className="menuCartBarIcon" />
                <div className="menuCartBarText">
                  <span className="menuCartBarCount">
                    {totalItems} {t("items")}
                  </span>
                  <span className="menuCartBarTotal">
                    {t("Invoice.total_price")}:{' '}
                    <span className="menuCartBarTotalValue">
                      {totalPrice}{" "}
                      {localStorage.getItem("countryId") === "1" ? (
                        <span className="icon-saudi_riyal"></span>
                      ) : (
                        t("CurrencyBH")
                      )}
                    </span>
                  </span>
                </div>
              </div>
              <Link to="/cart" className="menuCartBarButton">
                {t("Bottom_Nav.basket")}
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default MainPage;
